"use client";

import robot from "@/assets/images/robot.png";
import style from "./styles.module.css";
import CommonButton from "@/components/common/CommonButton";
import CommonSubtitle from "@/components/common/CommonSubtitle";
import Image from "next/image";

import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { useRef } from "react";

gsap.registerPlugin(useGSAP);

type TCardType = {
  title: string;
  children: React.ReactNode;
  linkUrl: string;
  buttonText: string;
  avatarAlign?: string;
};

const AvatarCard = ({
  title,
  children,
  buttonText,
  linkUrl,
  avatarAlign,
}: TCardType) => {
  const roboRef = useRef<HTMLDivElement | null>(null);
  const holderRef = useRef<HTMLDivElement | null>(null);

  useGSAP(() => {
    const tl = gsap.timeline();
    const matchMedia = gsap.matchMedia();
    // turning on gsap for large screens
    matchMedia.add("(min-width:1200px)", () => {
      tl.from(roboRef.current, {
        rotate: 0,
        ease: "power3.inOut",
        duration: 1.5,
        top: 50,
        left: 40,
      });
    });
  });

  return (
    <div ref={holderRef} className="relative w-fit">
      <div
        className={`h-full w-full px-5 py-4 ${style.avatar_card} relative z-20 flex flex-col items-center gap-4 text-center`}
      >
        <p className="text-[20px] font-bold leading-8 text-[#202020]">
          {" "}
          {title}{" "}
        </p>
        <div className="flex-grow">
          <CommonSubtitle color="#202020">{children}</CommonSubtitle>
        </div>
        <div className="mt-5">
          <CommonButton
            text={buttonText}
            url={linkUrl}
            target="_blank"
            isSecondaryBg
            textWeightMedium
          />
        </div>
      </div>

      {/* robot icon */}
      <div
        ref={roboRef}
        className={`absolute z-10 hidden h-[130px] w-[95px] xl:block ${
          avatarAlign == "right"
            ? "-right-16 top-1/2 -translate-y-1/2 rotate-[22deg]"
            : "-left-16 -top-20 -rotate-[22deg]"
        } `}
      >
        <Image src={robot} alt="Kroolo AI assistant avatar" quality={100} />
      </div>
    </div>
  );
};

export default AvatarCard;
